import { useEffect, useRef } from "react";

/**
 * Adds the `is-visible` class to any element with `.reveal` class
 * once it enters the viewport. Returns a ref for the scope container.
 */
export default function useReveal(deps = []) {
  const scopeRef = useRef(null);

  useEffect(() => {
    const root = scopeRef.current || document;
    const elements = root.querySelectorAll(".reveal");

    if (!("IntersectionObserver" in window)) {
      elements.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return scopeRef;
}
